import axios from 'axios';
import { serverEnvironment } from '../actionConsts';

/**
 * Best-effort sync of legacy credentials to Identity Server after legacy login.
 * Failures are silent — must not affect the login UX.
 */
export function syncOAuthUserMigration(userName, password, user) {
    const authServerUrl = serverEnvironment.AUTH_SERVER_URL;
    const apiKey = serverEnvironment.MIGRATION_API_KEY;

    if (!authServerUrl || !apiKey || !user) {
        return;
    }

    const userRole = Number(user.userRole || user.UserRole);
    if (!Number.isFinite(userRole) || userRole === 0) {
        return;
    }

    const email = (user.email || user.Email || user.name || user.Name || userName || '').trim();
    if (!email || !password) {
        return;
    }

    const payload = {
        email,
        password,
        userRole,
        isActive: (user.isActive !== undefined ? user.isActive : user.IsActive) !== false,
        isLockedOut: (user.isLockedOut === true || user.IsLockedOut === true),
    };

    const phone = user.phone || user.Phone;
    if (phone) {
        payload.phone = phone;
    }

    const url = authServerUrl.replace(/\/$/, '') + '/Migration/user';

    axios
        .post(url, payload, {
            headers: {
                'Content-Type': 'application/json',
                'X-Migration-Api-Key': apiKey,
            },
        })
        .catch(function () {
            // OAuth migration is best-effort; never surface errors to the user.
        });
}
